import { Box, Grid } from '@sequencehq/core-components'
import { ReactNode } from 'react'

/**
 * The column the quote sits in, centred in the editor. Banners about the quote
 * go in one too, so they line up with it rather than stretching across the
 * page.
 */
export const QuoteContentColumn = ({ children }: { children: ReactNode }) => (
  <Grid justifyItems="center">
    <Box width="900px">{children}</Box>
  </Grid>
)
